/** Normalize meal option labels to canonical "Option N". */

/** Extract the option number from a title or number-like value. */
export function optionNumber(titleOrNum, fallbackIdx = 0) {
  if (titleOrNum == null || titleOrNum === '') {
    return String(fallbackIdx + 1);
  }
  const match = String(titleOrNum).trim().match(/\d+/);
  return match ? match[0] : String(fallbackIdx + 1);
}

/** Always return canonical `Option ${n}`. */
export function formatOptionTitle(title, idx = 0) {
  const raw = (title || '').toString().trim();
  if (!raw) return `Option ${idx + 1}`;
  return `Option ${optionNumber(raw, idx)}`;
}

/**
 * Look up an option id. Prefers canonical key; falls back to number match for
 * any legacy mixed-case keys still in memory.
 */
export function findOptionId(optionIds = {}, numOrTitle) {
  if (!optionIds || numOrTitle == null || numOrTitle === '') return undefined;
  const key = formatOptionTitle(numOrTitle);
  if (Object.prototype.hasOwnProperty.call(optionIds, key)) return optionIds[key];
  const want = optionNumber(numOrTitle);
  for (const [k, id] of Object.entries(optionIds)) {
    if (optionNumber(k) === want) return id;
  }
  return undefined;
}

export function optionIdsHas(optionIds, numOrTitle) {
  return findOptionId(optionIds, numOrTitle) !== undefined;
}
